<template>
  <router-link :to="'/special-services/'+experience.id" class="no-style" >
    <div class="mb-4">
      <div class="cover-experience-photo-sm bg-dark mb-3">
        <img v-lazy="getCoverImage(experience.experience_photos)"
             :alt="experience.title"
             class="img-experience-photo">
      </div>
      <div class="d-flex justify-content-start align-items-center">
        <div class="flex-fill experience-category">
          <span v-html="$options.filters.serviceParentName(experience.service_id, globalState.services)"></span>
          •
          {{ globalState.cities[experience.province_id] | multiLangName }}
        </div>
        <div class="flex-fill text-right text-small" v-if="Number(experience.num_rating) > 0">
          <i class="fas fa-star -rating-star mr-0"></i> {{ Number(experience.avg_rating).toFixed(1) }}
          ({{ experience.num_rating }})
        </div>
      </div>

      <div class="experience-item-title pt-1">
        <span v-html="$options.filters.shortText(experience.title, 80)"></span>
      </div>
      <template v-if="displayCost">
        <div class="pt-2 experience-item-price" v-if="experience.cost">
          <h3 class="d-inline-block text-info">{{ experience.cost | currency }}</h3>
          {{ $t('message.experience.starting_at') }}
          <span v-if="experience.duration > 0">
            •
            {{ experience.duration }}
            {{ $tc('message.hour', experience.duration) }}
          </span>
        </div>
        <div class="pt-2" v-else>
          <span class="border border-info px-2 text-info text-small rounded-pill">
            <label>{{ $t('message.experience.evaluate') }}</label>
          </span>
        </div>
      </template>
    </div>
  </router-link>
</template>

<script>
  import { mapGetters } from 'vuex'

  export default {
    props: {
      experience: Object,
      displayCost: Boolean
    },
    computed: {
      ...mapGetters({
        globalState: 'globalVal/getState'
      })
    },
    methods: {
      getCoverImage (experiencePhotos) {
        let imageUrl = experiencePhotos[0].image_sm
        const ext = imageUrl.split('.').pop()
        if (ext === 'mp4') {
          imageUrl = experiencePhotos[1].image_sm
        }
        return imageUrl
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/experience/Experience.vue